import * as types from "../types";

const initialState = {
  data: [],
  totalCount: 0,
  isLoading: false,
  error: null,
};

export default function campaignLogsReducer(state = initialState, action) {
  switch (action.type) {
    case types.CAMPAIGN_LOGS:
      return {
        ...state,
        ...action.payload,
      };
    case types.IS_LOGS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
